import { Claim } from './types';
import { ReduxAction } from '../core';

export class ClaimsAction {
  public static SET_IS_FETCHING = `CLAIMS/SET_IS_FETCHING`;
  public static SET_CLAIMS = `CLAIMS/SET_CLAIMS`;
  public static SUBMIT_CLAIM = `CLAIMS/SUBMIT`;
  public static REFRESH_CLAIM = `CLAIMS/REFRESH`;
  public static RESET_CLAIM = `CLAIMS/RESET`;
  public static GENERATE_CLAIM = `CLAIMS/GENERATE`;
  public static ONE_UPDATED = `CLAIMS/UPDATED_ONE`;
  public static FETCH_ONE_CLAIM = `CLAIMS/FETCH_ONE`;
  public static FETCH_ONE_CLAIM_VISIT_CODE = `CLAIMS/FETCH_ONE_VISIT_CODE`;
}

export function setClaimsFetching(value: boolean): ReduxAction<boolean> {
  return {
    type: ClaimsAction.SET_IS_FETCHING,
    data: value,
  };
}

export function fetchOneClaim(id: string): ReduxAction<string> {
  return {
    type: ClaimsAction.FETCH_ONE_CLAIM,
    data: id,
  };
}

export function fetchOneLatestClaimByVisitCode(visitCode: string): ReduxAction<string> {
  return {
    type: ClaimsAction.FETCH_ONE_CLAIM_VISIT_CODE,
    data: visitCode,
  };
}

export function receivedUpdatedClaim(value: Claim): ReduxAction<Claim> {
  return {
    type: ClaimsAction.ONE_UPDATED,
    data: value,
  };
}

export function setClaims(value: Claim[]): ReduxAction<Claim[]> {
  return {
    type: ClaimsAction.SET_CLAIMS,
    data: value,
  };
}

export function generateClaim(
  visitCode: string,
  ignoreOldDataCheck: boolean,
  forceFinalizedClaimReplacement: boolean
): ReduxAction<{
  visitCode: string;
  ignoreOldDataCheck: boolean;
  forceFinalizedClaimReplacement: boolean;
}> {
  return {
    type: ClaimsAction.GENERATE_CLAIM,
    data: {
      visitCode: visitCode,
      ignoreOldDataCheck: ignoreOldDataCheck,
      forceFinalizedClaimReplacement: forceFinalizedClaimReplacement,
    },
  };
}

export function submitClaim(claimId: string): ReduxAction<string> {
  return {
    type: ClaimsAction.SUBMIT_CLAIM,
    data: claimId,
  };
}

export function refreshClaim(claimId: string): ReduxAction<string> {
  return {
    type: ClaimsAction.REFRESH_CLAIM,
    data: claimId,
  };
}

export function resetClaim(claimId: string): ReduxAction<string> {
  return {
    type: ClaimsAction.RESET_CLAIM,
    data: claimId,
  };
}
